import { Box, Slide, Stack, Typography, useMediaQuery } from "@mui/material";
import { useProduct } from "../store/product";

const styles = {
  ellipsis: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    fontSize: '1em'
  },
  image: {
    width: '3em',
    height: '3em',
    borderRadius: '3em',
    marginRight: theme => theme.spacing(1),
    backgroundSize: 'cover',
    flexShrink: 0,
    border: '2px solid white',
    boxShadow: theme => theme.shadows[2],
  }
};

function ProductInfo() {
  const shown = useProduct((state) => state.showInfo);
  const onClick = (e) => {
    useProduct.setState({ showInfo: false });
  }
  return (
    <Box sx={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      height: '100vh',
      pointerEvents: shown ? 'initial' : 'none',
      zIndex: theme => theme.zIndex.modal,
    }}>
      <Slide 
        direction="up"
        in={shown}
      >
        <Stack sx={{
          background: theme => theme.palette.action.active,
          height: '100%'
        }}>
          <button onClick={onClick}>hide</button>
        </Stack>
      </Slide>
    </Box>
  )
};

const ProductCard = () => {
  const product = useProduct((state) => state.product);
  const isSM = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  
  const onClick = (e) => {
    useProduct.setState({ showInfo: !useProduct.getState().showInfo });
  };

  return (
    <>
      {/* <ProductInfo /> */}
      <Stack
        className="cp-product-card"
        direction={'row'}
        display={'flex'}
        alignItems={'center'}
        flex={1}
        width={'100%'} 
        sx={{
          overflow: 'hidden',
          py: theme => theme.spacing(1),
          pr: theme => theme.spacing(2),
        }}
      >
        {product.gui && <Box sx={styles.image} style={{ backgroundImage: `url(${product.gui})` }} />}
        {/* {isSM && <Box onClick={onClick}>Info</Box>} */}
        {!isSM && (
          <Stack style={{ overflow: 'hidden', textAlign: 'left' }}>
            <Typography variant={'h6'} style={styles.ellipsis}>
              {product.name}
            </Typography>
            <Typography sx={{ opacity: 0.6, fontSize: '1em', ...styles.ellipsis }}>
              {product?.cat?.map((cat, key) => cat.label).join(', ')}
            </Typography>
          </Stack>
        )}
      </Stack>
    </>
  );
};

export default ProductCard;